export default __webpack_public_path__ + "static/media/maths-icon.62da295e.webp";